import { CarEspIcon } from './CarEspIcon';

/**
 * author: Michael Irigoyen
 * id 5BF118F1-1115-4928-8755-34AF926CF13D
 * name car-esp
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/car-esp.svg
 * tags
 * - Automotive 
 */
export const ElectronicStabilityProgramIcon = CarEspIcon;
export default ElectronicStabilityProgramIcon